const codes =  {
  gr: '_a48dde2c965e7e5b?lang=el&selected_currency=EUR',
  al: '_74f2b542fdbbc4c5?lang=en-gb&selected_currency=EUR',
  au: '_d47afd38ae01739?lang=en-gb&selected_currency=AUD',
  ca: '_530334ce3aa7d64?lang=en-gb&selected_currency=CAD',
  cn: '_b9d7d9306496166?lang=zh-cn&selected_currency=CNY',
  tp: '_71097b37de794df?lang=en-gb&selected_currency=EUR',
  tr: '_4afa590b5231b1d?lang=tr&selected_currency=TL',
  de: '_8a44534574fc5?lang=de&selected_currency=EUR',
  es: '_5d24f7d916c90055?lang=es&selected_currency=EUR',
  fr: '_77cabc3f1704aa4da?lang=fr&selected_currency=EUR',
  ie: '_e781c995efdfb?lang=en-gb&selected_currency=EUR',
  in: '_a7fd8062181b64e?lang=en-gb&selected_currency=INR',
  it: '_65e52917ba8e33418?lang=it&selected_currency=EUR',
  nl: '_e2b7c9e58ef5?lang=nl&selected_currency=EUR',
  pl: '_cd8675c75c031?lang=pl&selected_currency=PLN',
  ro: '_ed783d82acea?lang=ro&selected_currency=EUR',
  rs: '_e5fce76b40d42d2?lang=sr&selected_currency=RSD',
  ru: '_7122553719db0?lang=ru&selected_currency=RUB',
  uk: '_9af7d5f222c9369c?lang=en-gb&selected_currency=GBP',
  us: '_ff9a4938863222b4?lang=en-us&selected_currency=USD'
};

const cities = (isGRLocale) => [
  isGRLocale ? 'Λονδίνο' : 'London',
  isGRLocale ? 'Βρυξέλλες' : 'Brussels',
  isGRLocale ? 'Κρακοβία' : 'Milan',
  isGRLocale ? 'Ρώμη' : 'Krakow',
  isGRLocale ? 'Βερολίνο' : 'Berlin'
];

function hotelStore({market, brandLocale, translations}) {
  const {main, seo, deals} = translations;

  return {
    searcMask: {
      code: codes[market],
      translations: {...main}
    },
    seo: {
      translations: {...seo}
    },
    deals: {
      cities: cities(brandLocale === 'el_GR'),
      translations: {...deals}
    }
  };
}

export default hotelStore;
